import React, { useContext } from 'react';
import { useHistory, useLocation } from 'react-router';
import cx from 'classnames';

import { UserContext } from 'Context/user';

import { useFeatureFlags } from 'Utilities/hooks';
import routing from 'Utilities/routing';

import { routes } from '../../../routes';
import { useAuthUI } from '../experiments/useAuthUI/useAuthUI';
import { CAR_PRIZE_JAN_26_URL } from '../homepage/Components/CarPrizeJan2026/CarPrizeJan2026.helpers';
import { CarPrizeJan2026Banner } from '../homepage/Components/CarPrizeJan2026/CarPrizeJan2026Banner';

import styles from './Header.scss';

export const HeaderBackground: React.FC = () => {
  const { pathname } = useLocation();
  const { userState } = useContext(UserContext);
  const { isAuthUIJourney } = useAuthUI();
  const { showCarPrizeJan2026 } = useFeatureFlags();

  const route = routing.getMatch(pathname, routes);
  const user = Number.isInteger(userState?.id);

  const isHomePage = ['/', '/mileage'].includes(pathname);
  const isSignInPage = route.vrmPath && isAuthUIJourney && !user;
  const showCarPrizeBanner = showCarPrizeJan2026 && (isHomePage || CAR_PRIZE_JAN_26_URL === pathname);

  const history = useHistory<{ animateFromNewHomePage?: boolean }>();
  const { animateFromNewHomePage } = history?.location?.state ?? {};

  return (
    <>
      {showCarPrizeBanner && <CarPrizeJan2026Banner />}
      <div className={cx(styles.headerBackground, {
        [styles.isTranslucent]: (isHomePage || (isSignInPage && !!animateFromNewHomePage)),
        [styles.animated]: !!animateFromNewHomePage,
      })} />
    </>
  );
};
